@if(!accordionState()) {
<div>Mangler accordion state</div>
} @else { @let accordion = accordionState();
<div class="accordion-wrapper" [class.expanded]="accordion.expanded()" [id]="accordion.section()">
    <div class="header-wrapper flexspaceb" (click)="expanderClicked()">
        <div class="header flexspaceb">
            <div class="header-text">{{ accordion.title() }}</div>

            @if (accordion.isLoading()) {
            <ev-logo-loader class="header-loader" variant="dots" width="24px" />
            } @else {
            <div class="infographic-wrapper">
                @if (accordion.counter()) {
                <span class="counter">{{ accordion.counter() }}</span>
                } @if (accordion.tooltip()) {
                <span (click)="toggleTooltip($event)" class="info-tooltip">
                    <ev_tooltip
                        [visible]="tooltipVisible"
                        [right]="-150"
                        [top]="-160"
                        [arrow]="'bottom'"
                        [arrowAlignRight]="155"
                        [arrowTopAlign]="151"
                        [title]="accordion.tooltip().header"
                        [width]="360"
                        (clickOutside)="tooltipVisible = false"
                    >
                        <div class="score-popup">
                            <div class="score-dialog">
                                {{ accordion.tooltip().content }}
                            </div>
                        </div>
                    </ev_tooltip>
                </span>
                }
            </div>
            }
        </div>
        @if(accordion.expanded()) {
        <div class="toolbar flexend" [class.expanded]="accordion.expanded()">
            <ng-content select=".accordion-toolbar"></ng-content>
        </div>
        } @if (accordion.lastUpdated()) {
        <div [class.expanded]="accordion.expanded()" class="last-updated">Kilde: Kartverket per {{ accordion.lastUpdated() | date : "dd.MM.yyyy" }}</div>
        }

        <div class="expander">
            <ev-expanded-icon [expanded]="accordion.expanded()" [size]="22" [highlightColor]="'white'"></ev-expanded-icon>
        </div>
    </div>

    @if (accordion.expanded()) { @if (accordion.isLoading()) {
    <div class="info">
        <ev-logo-loader width="70px" />
    </div>
    }@else{
    <div class="content-wrapper">
        @if (!accordion.hasInfo() && !accordion.hasError()) {
        <ng-content></ng-content>
        } @if (accordion.hasInfo() || accordion.hasError()) {
        <div class="info column-100">
            @if (accordion.hasError()) {
            <div class="icon error-icon"></div>
            <div class="infotext">{{ accordion.errortext() || "Får ikke kontaktet server. Vent litt og prøv igjen." }}</div>
            } @else if (accordion.hasInfo()) {
            <div class="icon info-icon"></div>
            <div class="infotext">{{ accordion.infotext() || "Ingen " + accordion.title() + " for denne eiendommen" }}</div>
            }
        </div>
        }
    </div>
    } }
</div>
}
